import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { postImportICal, postImportICalLite } from 'modules/_common/api';
import { useLite } from 'modules/_common/hooks';

export const useMutationImportiCal = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const queryClient = useQueryClient();
  const { isLite } = useLite();
  const apiCall = isLite ? postImportICalLite : postImportICal;

  return useMutation(apiCall, {
    onSuccess: () => {
      successToast(t('iCal connection imported successfully.'));
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CM_ICAL_UNIT);
    },
    onError: (error: any) => {
      for (const [_, value] of Object.entries(error?.response?.data)) {
        if (!value) return;

        const { importUrl } = value as { importUrl: string };
        if (importUrl) {
          errorToast(t('Invalid iCal link'));
        }
      }
    },
  });
};
